import React from "react";
import { Bar } from "react-chartjs-2";

export default ({ fill = true, width = 100, height = 65, data = null }) => {
	const staticOptions = {
		lineTension: 0.1,
		borderWidth: 0,
		borderCapStyle: "butt",
		borderDash: [],
		borderDashOffset: 0.0,
		borderJoinStyle: "miter",
		pointBackgroundColor: "#fff",
		pointBorderWidth: 1,
		pointHoverRadius: 5,
		pointRadius: 1,
		pointHitRadius: 10,
		cubicInterpolationMode: "monotone"
	};

	const options = {
		scales: {
			xAxes: [
				{
					stacked: true,
					maxBarThickness: 30,
					gridLines: {
						display: false
					}
				}
			],
			yAxes: [
				{
					stacked: true
				}
			]
		}
	};

	const labels = data && data.data_categories ? data.data_categories : [];
	const datasets =
		data && data.data_series
			? data.data_series.map((item) => {
				return {
					label: item.name,
					backgroundColor: item.color,
					borderColor: item.color,
					pointBorderColor: item.color,
					data: item.data.map((dataItem) => dataItem.y),
					fill,
					...staticOptions
				};
			})
			: [];
	const chartData = {
		labels,
		datasets
	};

	return <Bar data={chartData} options={options} legend={null} width={width} height={height} />;
};
